module.exports = __webpack_public_path__ + "a4dc151c313ced1a681953f5ce192dac.svg";